<template>
  <div v-if="isBannerLineVisible && !isBannerLineClosed" class="banner-line d-flex justify-center align-center size5 text-center" :class="{'--hidden': isHidden}">
    <svgicon class="banner-line__icon" name="banner-line" :original="true" />
    <div class="d-md-none">{{ textMobile }}</div>
    <div class="d-none d-md-block">{{ textDesktop }}</div>
    <svgicon @click="onCloseClick" class="banner-line__close" name="cross" :original="true" />
  </div>
</template>

<script>
export default {
  name: 'banner-line',
  data: () => {
    return {
      isHidden: false,
    }
  },
  computed: {
    textDesktop() {
      return this.$store.state.common?.texts?.BANNER_LINE?.DETAIL_TEXT;
    },
    textMobile() {
      return this.$store.state.common?.texts?.BANNER_LINE?.PREVIEW_TEXT;
    },
    isBannerLineVisible() {
      return !!this.$store.state.common?.texts?.BANNER_LINE;
    },
    isBannerLineClosed() {
      return localStorage.getItem('isBannerLineClosed');
    }
  },
  methods: {
    onCloseClick() {
      this.isHidden = true;
      localStorage.setItem('isBannerLineClosed', '1');
    }
  }
}
</script>

<style lang="scss">
.banner-line {
  position: fixed;
  top: 76px;
  width: 100vw;
  padding: 10px 20px;
  background: $red3;
  color: $golden2;
  z-index: 50;
  gap: 30px;
  @include transition-long();

  @include up($md) {
    top: 113px;
    padding: 2px 40px;
  }

  @include up($lg) {
    top: 123px;
  }

  &.--hidden {
    opacity: 0;
  }

  &__icon {
    width: 60px;
    min-width: 60px;
  }

  &__close {
    width: 16px;
    min-width: 16px;
    cursor: pointer;
    padding: 2px;
    @include transition();

    &:hover {
      opacity: 0.7;
    }
  }
}
</style>